export const config = window.env;
